import {Component} from '@angular/core';
import {CookieService} from "../../_services/cookie.service";
import {SwitchComponent} from "../../_modules/x-components/switch/switch.component";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-cookie-settings',
  templateUrl: './cookie-settings.component.html',
  imports: [
    CommonModule,
    SwitchComponent
  ],
  styleUrls: ['./cookie-settings.component.scss']
})
export class CookieSettingsComponent {
  constructor(public CookieService: CookieService) {
  }
}
